<template>
  <BaseModal
    name="addBalanceFirstStepModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="() => (fileUrl = '')"
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('addBalanceFirstStepModal')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-app-modal__title">{{ dataLang["reg_company_45"] }}</div>

        <div class="tw-app-modal__title tw-text-forText">
          {{ dataLang["reg_company_48"] }}
        </div>

        <div class="tw-flex tw-justify-center">
          <div class="tw-text-left" v-html="dataLang['reg_company_46']"></div>
        </div>

        <div>
          <div class="tw-flex tw-gap-[10px] tw-justify-center tw-mt-[15px]">
            <div
              v-if="fileUrl"
              class="tw-app-btn-primary tw-min-w-[150px] tw-justify-center"
              @click="
                () => {
                  fileUrl = '';
                }
              "
            >
              {{ dataLang["vehile_modal_btn_delete"] }}
            </div>
            <label
              v-if="!fileUrl"
              class="tw-app-btn-primary tw-min-w-[210px] tw-justify-center"
            >
              {{ dataLang["reg_company_47"] }}
              <input
                type="file"
                class="d-none"
                accept=".xlsx"
                @change="loadFile"
              />
            </label>
            <a
              :href="fileUrl"
              target="_blank"
              v-if="fileUrl"
              class="tw-app-btn-primary-outline"
            >
              <img :src="require(`@/assets/icons/to-exel.svg`)"" />
            </a>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('addBalanceFirstStepModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg tw-min-w-[100px]"
            >
              {{ dataLang["clients_register_text_96"] }}
            </button>
            <button
              @click="sendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg tw-min-w-[100px] tw-justify-center"
            >
              {{ dataLang["reg_company_24"] }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      localLoading: false,
      dataForEmit: {},
      pincode: "",
      currentId: null,
      fileUrl: "",
    };
  },
  methods: {
    loadData({ params }) {
      this.pincode = params?.pincode;

      // /clients/table/active?count=0&limit=100&total=0&page=0
    },
    async loadFile(e) {
      this.localLoading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "bank_document_xlsx");

      try {
        let dataFrom = await GeneralService.editOrCreate("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileUrl = dataFrom.data.data.url;
        this.localLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (this.fileUrl) {
        this.localLoading = true;
        GeneralService.editOrCreate(
          `/super/companies/balance/in/step2?pincode=${this.pincode}`,
          {
            link: this.fileUrl,
          }
        )
          .then((gege) => {
            console.log(gege);
            this.$toast.success(gege.data.message);
            this.$modal.show("addBalanceSecondStepModal", {
              dataTable: gege.data.data,
              link: this.fileUrl,
              pincode: this.pincode,
            });
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("addBalanceFirstStepModal");
            this.localLoading = false;
          });
      } else {
        this.$toast.error("Сначала загрузите файл", { duration: 5000 });
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
